module.exports = __webpack_public_path__ + "static/img/04-ci.1ef2cb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter/04-ci.png
// module id = qQYP
// module chunks = 1